<template>
  <div v-if="!item.hidden">
    <el-submenu v-if="showSubmenu" :index="submenuIndex">
      <template slot="title">
        <i :class="submenuIcon"></i>
        <span>{{ submenuTitle }}</span>
      </template>
      <sidebar-item
        v-for="child in visibleChildren"
        :key="`${submenuIndex}-${child.path || child.name}`"
        :item="child"
        :base-path="submenuIndex"
      />
    </el-submenu>

    <el-menu-item v-else :index="menuIndex">
      <i :class="menuIcon"></i>
      <span slot="title">{{ menuTitle }}</span>
    </el-menu-item>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  computed: {
    visibleChildren() {
      return (this.item.children || []).filter(child => !child.hidden)
    },
    shouldCollapseToSingle() {
      return !this.item.name && this.visibleChildren.length === 1 && !(this.item.meta && this.item.meta.alwaysShow)
    },
    showSubmenu() {
      return this.visibleChildren.length > 0 && !this.shouldCollapseToSingle
    },
    singleRoute() {
      if (this.shouldCollapseToSingle) {
        return this.visibleChildren[0]
      }
      return this.item
    },
    submenuIndex() {
      return this.resolvePath(this.item.path || this.singleRoute.path)
    },
    submenuTitle() {
      return (this.item.meta && this.item.meta.title) || (this.singleRoute.meta && this.singleRoute.meta.title) || ''
    },
    submenuIcon() {
      return (this.item.meta && this.item.meta.icon) || (this.singleRoute.meta && this.singleRoute.meta.icon) || 'el-icon-menu'
    },
    menuIndex() {
      return this.resolvePath(this.singleRoute.path || this.item.path)
    },
    menuTitle() {
      return (this.item.meta && this.item.meta.title) || (this.singleRoute.meta && this.singleRoute.meta.title) || ''
    },
    menuIcon() {
      return (this.item.meta && this.item.meta.icon) || (this.singleRoute.meta && this.singleRoute.meta.icon) || 'el-icon-menu'
    }
  },
  methods: {
    resolvePath(routePath) {
      if (!routePath) {
        return this.basePath || '/'
      }
      if (routePath.startsWith('/')) {
        return routePath
      }
      const base = this.basePath.endsWith('/') ? this.basePath.slice(0, -1) : this.basePath
      return `${base}/${routePath}`.replace(/\/+/g, '/')
    }
  }
}
</script>
